import type { ComponentDocMap } from './types'

/**
 * Prop documentation for the `real_time_optimization_bars` anchor component.
 * Keep in sync with RealTimeOptimizationBarsProps in src/ui/uiConfig/anchorComponents/RealTimeOptimizationBars/RealTimeOptimizationBars.types.ts
 */
export const realTimeOptimizationBarsPropDocs: ComponentDocMap = {
  items: {
    description: 'Bar card definitions. Uses chart item schema (title, data_id, color, unit, etc.).',
    type: 'ChartItem[]',
    example: '[{ title: "__Optimal", data_id: "optimal", color: "$color-1" }]',
  },
  show_warning_at_age_in_minute: {
    description: 'Age threshold in minutes before warning styling appears.',
    type: 'number',
    example: '20',
  },
  card_width: {
    description: 'Width of each rendered bar card in pixels.',
    type: 'number',
    example: '280',
  },
  highlight_diff_at: {
    description: 'Difference threshold that activates highlighted diff style.',
    type: 'number',
    example: '5',
  },
}
